import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface ConfettiPiece {
  id: number
  x: number
  y: number
  color: string
  rotation: number
  delay: number
  size: number
}

interface ConfettiEffectProps {
  active: boolean
  duration?: number
}

const colors = ['#ff6b35', '#ff8c42', '#ffa500', '#ffb347', '#ffd700']

export function ConfettiEffect({ active, duration = 3000 }: ConfettiEffectProps) {
  const [confetti, setConfetti] = useState<ConfettiPiece[]>([])
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (active) {
      // Generate confetti pieces
      const pieces: ConfettiPiece[] = Array.from({ length: 50 }, (_, i) => ({
        id: i,
        x: Math.random() * window.innerWidth,
        y: -10,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        delay: Math.random() * 1000,
        size: Math.random() * 8 + 4
      }))
      
      setConfetti(pieces)
      setIsVisible(true)
      
      // Hide after duration
      setTimeout(() => {
        setIsVisible(false)
      }, duration)
    }
  }, [active, duration])

  if (!isVisible) return null

  return (
    <div className="fixed inset-0 pointer-events-none z-[60] overflow-hidden">
      <AnimatePresence>
        {confetti.map((piece) => (
          <motion.div
            key={piece.id}
            initial={{
              x: piece.x,
              y: piece.y,
              rotate: piece.rotation,
              opacity: 0,
              scale: 0
            }}
            animate={{
              y: window.innerHeight + 100,
              rotate: piece.rotation + 720,
              opacity: [0, 1, 1, 0],
              scale: [0, 1, 1, 0]
            }}
            transition={{
              duration: 3,
              delay: piece.delay / 1000,
              ease: "easeOut"
            }}
            className="absolute"
            style={{
              backgroundColor: piece.color,
              width: `${piece.size}px`,
              height: `${piece.size}px`,
              borderRadius: Math.random() > 0.5 ? '50%' : '2px'
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  )
} 